<div class="background">
  <app-website-header></app-website-header>
  <app-carousel></app-carousel>
  
    <div class=" align-items-center d-md-none brands-headline">
      <div class="d-flex justify-content-between  align-items-center brands-header" style="background-color:#0D87C8">
        <h2 class="brands" style="font-weight: bolder;font-size:12; font-family: 'Georgia' !important; ">
          <img src="../../../../assets/images/brands-ribbon-icon.svg" width="24px" height="24px" alt="" style="margin-right: 8px; margin-top: -2px;"> Brands</h2>
      </div>
    </div>
  <div class="breadcrumb-div">
    <img class="breadcrumb-icon" src="../../../assets/images/icons/home-icon.svg" style="margin-top: -4px;" alt="" [routerLink]="['/']">
    <a class="breadcrummb ps-2" style="color:#0D87C8 ;" [routerLink]="['/']">Home</a>
    <a class="breadcrummb" style="color:#0D87C8 ;">/</a>
    <a class="breadcrummb" style="color:#0D87C8 ;">Brands</a>
  </div>
  <div class="container-fluid">
    <div class="row" >
      <div class="col-lg-3">
        <app-brand-filters [data]="originalData" (filteredData)="onFilteredData($event)"></app-brand-filters>
      </div>
      <div class="col-lg-9">
        <div class="row d-none d-md-block" style="width:99%;">
          <div class="d-flex justify-content-between  align-items-center brands-header">
            <h2 class="brands" style="font-weight: bolder;font-size:12; font-family: 'Georgia' !important; ">
              <img src="../../../../assets/images/brands-ribbon-icon.svg" width="24px" height="24px" alt="" style="margin-right: 8px; margin-top: -2px;"> Brands</h2>
          </div>
        </div>
        <div *ngIf="showNoRecordsFounds" class="no-results">
          <img src="../../../../assets/images/Empty bin.png" alt="no-records-found" class="no-results-image">
          <div class="no-records-found"> No Brands Found </div>
        </div>
        <div class="row brands-card" >
          <div class="col-lg-4 col-md-6 col-sm-6 brand-card" *ngFor="let brand of paginatedItems; let i = index"> 
       
          <div style="position: relative;" (click)="viewPortfolio(brand)" class="card" (mouseenter)="hoveredIndex = i" (mouseleave)="hoveredIndex = -1"
              [ngStyle]="{'background-color': hoveredIndex === i ? 'rgba(0, 0, 0, 0.6)' : 'white', 'color': hoveredIndex === i ? '#fff' : 'inherit',}">
              <img height="220" [src]="brand.logo" class="card-img-top" alt="{{brand.name}}"
                [style.opacity]="hoveredIndex === i ? 0.1 : 1"/>
              <p class="brand-name" [style.opacity]="hoveredIndex === i ? 0.1 : 1">{{brand.name}}</p>
              <p class="text-center" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);" [style.display]="hoveredIndex === i ? 'block' : 'none'"
                [style.background-color]="hoveredIndex === i ? '' : 'rgba(0, 0, 0, 0.6)'"
                [style.color]="hoveredIndex === i ? '#fff' : 'rgba(0, 0, 0, 0.6)'" [style.font-weight]="'600'">
                View {{brand.name}} Portfolio
              </p>
            </div>
          
        </div>
      </div>
    </div>
    <div class="pagination-container d-flex flex-column flex-lg-row align-items-center">
      <app-dynamic-pagination [itemsPerPage]="itemsPerPage" [data]="brands" (pageChanged)="onPageChanged($event)"></app-dynamic-pagination>
      <p class="end-text" style="color: #0D87C8;margin-left: 25px;">Total Entries: {{brands.length}}</p>
    </div>
    </div>
  </div>
  <app-website-footer></app-website-footer>